import { CountryPhoneCodeModel } from './countries-phone-helper.service';
import * as countryList from '../../assets/country-phone-data.json';

export const PhoneCountryList: CountryPhoneCodeModel[] = (countryList as any).default;
